webpackJsonp([12],{

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(20)(
  /* script */
  __webpack_require__(642),
  /* template */
  __webpack_require__(845),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7f8ff484",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 642:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(26);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import firebase from "firebase";

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lsLocs: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              /*this.$store.commit('query_location', {
                  //empty
                })*/
              //
              _this.lsLocs = _this.getLocsFromLs();
              _this.clearSearch();
              //
              // testing token ;))
              /* let currentUser = await firebase.auth().currentUser
                if (currentUser) {
                  let token = await currentUser.getIdToken(true)
                  console.log({ token })
                }
                else {
                  console.log('YOU ARE NOT LOGGED IN !')
                } */
              // testing token ;))
              //

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(["queried_locations"])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapMutations */])(["query_location"]), {
    //
    goToRoute: function goToRoute(selected) {
      localStorage.removeItem("homePageImages");
      var obj = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$route.query);
      obj.loc = selected;
      // console.log({ obj });
      var _from = localStorage.getItem("from");
      if (_from === "Map") {
        this.$router.push({ path: "/map", query: obj });
      } else {
        var _mode = localStorage.getItem("Mode");
        this.$store.state.common.isModeSwipe = _mode === null ? false : JSON.parse(_mode);
        this.$router.push({ path: "/", query: obj });
      }
    },

    //
    clearSearch: function clearSearch() {
      this.$store.state.search_loc.query_location = "";
      this.$store.state.search_loc.queried_locations = [];
    },

    //
    getLocsFromLs: function getLocsFromLs() {
      // get locs from ls
      var lsLocs = localStorage.getItem("searchedLocs");
      var lsLocs2 = [];
      if (lsLocs) {
        lsLocs2 = JSON.parse(lsLocs);
      } else {
        lsLocs2 = [];
      }
      lsLocs2.unshift({ name: "Worldwide", bold: false, pic_cnt: -1 });
      return lsLocs2;
      // /get locs from ls
    },

    //
    saveLocToLs: function saveLocToLs(newLoc) {
      // console.log({ saveLocToLs: newLoc });
      // check in ls, if loc exist, to avoid duplication
      var lsLocs = localStorage.getItem("searchedLocs");
      var alreadyExists = false;
      if (lsLocs) {
        lsLocs = JSON.parse(lsLocs);
        for (var i in lsLocs) {
          if (lsLocs[i].name === newLoc.name) {
            alreadyExists = true;
          }
        }
      }
      // check if it's worldwide
      var isWorldwide = false;
      if (newLoc.name === "Worldwide") {
        isWorldwide = true;
      }
      //
      //
      // console.log({ alreadyExists, isWorldwide });
      if (!alreadyExists && !isWorldwide) {
        if (!lsLocs) {
          lsLocs = []; // first time
        }
        // console.log("SAVE IN LS");
        lsLocs.push(newLoc);
        localStorage.setItem("searchedLocs", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(lsLocs));
      } else {
        // console.log("NOT SAVE IN LS");
      }
    }
    //

  })
});

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(536)(true);
// imports


// module
exports.push([module.i, ".search_location[data-v-7f8ff484]{background:#4a4a4a;position:relative;min-height:100vh;padding-bottom:5em}.search_location .first-row[data-v-7f8ff484]{padding-top:1.857em;padding-bottom:1.071em;color:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;width:100%}.search_location .first-row .clear-icon[data-v-7f8ff484]{position:relative;left:.8em;font-size:1.714em}.search_location .first-row .clear-btn[data-v-7f8ff484]{position:relative;right:1.2em;font-size:1em;font-weight:400}.search_location .search-container[data-v-7f8ff484]{width:100%;border-bottom:1px solid rgba(0,0,0,.2);padding-bottom:.2em}.search_location .search-container input[data-v-7f8ff484]{width:100%;padding-left:1em;padding-right:1.2em;outline:none;color:#fff;font-size:1.714em;font-weight:700}.search_location .result-locations-container .each-location[data-v-7f8ff484]{padding-top:1.429em;padding-left:1.55em;padding-right:1.5em}.search_location .result-locations-container .each-location .each-location-container[data-v-7f8ff484]{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding-bottom:1.357em;border-bottom:1px solid hsla(0,0%,61%,.2)}.search_location .result-locations-container .each-location .each-location-container ._left .icon-container[data-v-7f8ff484],.search_location .result-locations-container .each-location .each-location-container ._left[data-v-7f8ff484],.search_location .result-locations-container .each-location .each-location-container[data-v-7f8ff484]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.search_location .result-locations-container .each-location .each-location-container ._left .icon-container i[data-v-7f8ff484]{color:#9b9b9b;font-size:1.286em}.search_location .result-locations-container .each-location .each-location-container ._left .location-name[data-v-7f8ff484]{text-align:left;padding-left:.4em;color:#fff;font-size:.857em;position:relative;top:.1em}.search_location .result-locations-container .each-location .each-location-container ._right[data-v-7f8ff484]{color:#fff;font-size:.857em;position:relative;top:.2em}.search_location .main-more-container[data-v-7f8ff484]{position:absolute;bottom:0;width:100%}.search_location .main-more-container .filter-header-container[data-v-7f8ff484]{position:relative;margin-bottom:2em}.search_location .main-more-container .filter-header-container .div-1[data-v-7f8ff484]{padding:0 1em;font-size:1em;top:-.7em;right:1em;color:#9b9b9b;background:#4a4a4a;position:absolute}.search_location .main-more-container .filter-header-container .div-2[data-v-7f8ff484]{width:100%;height:1px;background:#000}.search-location-dropdown[data-v-7f8ff484]{width:100%;border:none;font-size:30px;color:#fff}.search-location-dropdown select[data-v-7f8ff484]{outline:none!important}.search-location-dropdown option[data-v-7f8ff484]{font-size:20px;color:#303030!important}", "", {"version":3,"sources":["/home/aubergine/Documents/GitHub/pwa2020/src/components/search_locations.vue"],"names":[],"mappings":"AACA,kCACE,mBAAoB,AACpB,kBAAmB,AACnB,iBAAkB,AAClB,kBAAoB,CACrB,AACD,6CACI,oBAAqB,AACrB,uBAAwB,AACxB,WAAe,AACf,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,UAAY,CACf,AACD,yDACM,kBAAmB,AACnB,UAAY,AACZ,iBAAmB,CACxB,AACD,wDACM,kBAAmB,AACnB,YAAa,AACb,cAAe,AACf,eAAoB,CACzB,AACD,oDACI,WAAY,AACZ,uCAA4C,AAC5C,mBAAsB,CACzB,AACD,0DACM,WAAY,AACZ,iBAAkB,AAClB,oBAAqB,AACrB,aAAc,AACd,WAAe,AACf,kBAAmB,AACnB,eAAkB,CACvB,AACD,6EACI,oBAAqB,AACrB,oBAAqB,AACrB,mBAAqB,CACxB,AACD,sGAOM,yBAA0B,AACtB,sBAAuB,AACnB,8BAA+B,AACvC,uBAAwB,AACxB,yCAAkD,CACvD,AASD,gVACU,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CACrC,AACD,+HACY,cAAe,AACf,iBAAmB,CAC9B,AACD,4HACU,gBAAiB,AACjB,kBAAoB,AACpB,WAAe,AACf,iBAAmB,AACnB,kBAAmB,AACnB,QAAW,CACpB,AACD,8GACQ,WAAe,AACf,iBAAmB,AACnB,kBAAmB,AACnB,QAAW,CAClB,AACD,uDACI,kBAAmB,AACnB,SAAU,AACV,UAAY,CACf,AACD,gFACM,kBAAmB,AACnB,iBAAmB,CACxB,AACD,uFACQ,cAAe,AACf,cAAe,AACf,UAAY,AACZ,UAAW,AACX,cAAe,AACf,mBAAoB,AACpB,iBAAmB,CAC1B,AACD,uFACQ,WAAY,AACZ,WAAY,AACZ,eAAkB,CACzB,AACD,2CACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,UAAa,CACd,AACD,kDACI,sBAAyB,CAC5B,AACD,kDACI,eAAgB,AAChB,uBAA0B,CAC7B","file":"search_locations.vue","sourcesContent":["\n.search_location[data-v-7f8ff484] {\n  background: #4a4a4a;\n  position: relative;\n  min-height: 100vh;\n  padding-bottom: 5em;\n}\n.search_location .first-row[data-v-7f8ff484] {\n    padding-top: 1.857em;\n    padding-bottom: 1.071em;\n    color: #ffffff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n    width: 100%;\n}\n.search_location .first-row .clear-icon[data-v-7f8ff484] {\n      position: relative;\n      left: 0.8em;\n      font-size: 1.714em;\n}\n.search_location .first-row .clear-btn[data-v-7f8ff484] {\n      position: relative;\n      right: 1.2em;\n      font-size: 1em;\n      font-weight: normal;\n}\n.search_location .search-container[data-v-7f8ff484] {\n    width: 100%;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.2);\n    padding-bottom: 0.2em;\n}\n.search_location .search-container input[data-v-7f8ff484] {\n      width: 100%;\n      padding-left: 1em;\n      padding-right: 1.2em;\n      outline: none;\n      color: #ffffff;\n      font-size: 1.714em;\n      font-weight: bold;\n}\n.search_location .result-locations-container .each-location[data-v-7f8ff484] {\n    padding-top: 1.429em;\n    padding-left: 1.55em;\n    padding-right: 1.5em;\n}\n.search_location .result-locations-container .each-location .each-location-container[data-v-7f8ff484] {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      -webkit-box-pack: justify;\n          -ms-flex-pack: justify;\n              justify-content: space-between;\n      padding-bottom: 1.357em;\n      border-bottom: 1px solid rgba(155, 155, 155, 0.2);\n}\n.search_location .result-locations-container .each-location .each-location-container ._left[data-v-7f8ff484] {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n            -ms-flex-align: center;\n                align-items: center;\n}\n.search_location .result-locations-container .each-location .each-location-container ._left .icon-container[data-v-7f8ff484] {\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-align: center;\n              -ms-flex-align: center;\n                  align-items: center;\n}\n.search_location .result-locations-container .each-location .each-location-container ._left .icon-container i[data-v-7f8ff484] {\n            color: #9b9b9b;\n            font-size: 1.286em;\n}\n.search_location .result-locations-container .each-location .each-location-container ._left .location-name[data-v-7f8ff484] {\n          text-align: left;\n          padding-left: 0.4em;\n          color: #ffffff;\n          font-size: 0.857em;\n          position: relative;\n          top: 0.1em;\n}\n.search_location .result-locations-container .each-location .each-location-container ._right[data-v-7f8ff484] {\n        color: #ffffff;\n        font-size: 0.857em;\n        position: relative;\n        top: 0.2em;\n}\n.search_location .main-more-container[data-v-7f8ff484] {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n.search_location .main-more-container .filter-header-container[data-v-7f8ff484] {\n      position: relative;\n      margin-bottom: 2em;\n}\n.search_location .main-more-container .filter-header-container .div-1[data-v-7f8ff484] {\n        padding: 0 1em;\n        font-size: 1em;\n        top: -0.7em;\n        right: 1em;\n        color: #9b9b9b;\n        background: #4a4a4a;\n        position: absolute;\n}\n.search_location .main-more-container .filter-header-container .div-2[data-v-7f8ff484] {\n        width: 100%;\n        height: 1px;\n        background: black;\n}\n.search-location-dropdown[data-v-7f8ff484] {\n  width: 100%;\n  border: none;\n  font-size: 30px;\n  color: white;\n}\n.search-location-dropdown select[data-v-7f8ff484] {\n    outline: none !important;\n}\n.search-location-dropdown option[data-v-7f8ff484] {\n    font-size: 20px;\n    color: #303030 !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(675);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(537)("bc2e3c24", content, true, {});

/***/ }),

/***/ 845:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search_location"
  }, [_c('div', {
    staticClass: "first-row"
  }, [_c('i', {
    staticClass: "material-icons clear-icon",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('div', {
    staticClass: "clear-btn pointer",
    on: {
      "click": function($event) {
        return _vm.clearSearch()
      }
    }
  }, [_vm._v("Clear")])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$store.state.search_loc.query_location),
      expression: "$store.state.search_loc.query_location"
    }],
    staticClass: "search-location-dropdown",
    attrs: {
      "data-dropup-auto": "false"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.$store.state.search_loc, "query_location", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.query_location,
        _vm.goToRoute(_vm.$store.state.search_loc.query_location)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Worldwide")]), _vm._v(" "), _c('option', [_vm._v("Barcelona")]), _vm._v(" "), _c('option', [_vm._v("Berlin")]), _vm._v(" "), _c('option', [_vm._v("Copenhagen (København)")]), _vm._v(" "), _c('option', [_vm._v("Florence (Firenze)")]), _vm._v(" "), _c('option', [_vm._v("Lisbon (Lisboa)")]), _vm._v(" "), _c('option', [_vm._v("London")]), _vm._v(" "), _c('option', [_vm._v("Los Angeles")]), _vm._v(" "), _c('option', [_vm._v("Madrid")]), _vm._v(" "), _c('option', [_vm._v("Milan (Milano)")]), _vm._v(" "), _c('option', [_vm._v("New York")]), _vm._v(" "), _c('option', [_vm._v("Paris")]), _vm._v(" "), _c('option', [_vm._v("Porto")]), _vm._v(" "), _c('option', [_vm._v("Rome (Roma)")]), _vm._v(" "), _c('option', [_vm._v("San Francisco")])])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-more-container"
  }, [_c('div', {
    staticClass: "filter-header-container"
  }, [_c('div', {
    staticClass: "div-1"
  }, [_vm._v("Select a filter to limit results")]), _vm._v(" "), _c('div', {
    staticClass: "div-2"
  })])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/v/1733832636781/js/12.b953b08e7cb4d33a574b.js